function pagination_click_fun(){
  let loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;
  if(loadMoreBtn){
    loadMoreBtn.addEventListener("click",function(e) {
      e.preventDefault();
      pagination_items_get_fun(loadMoreBtn.getAttribute("href"));
    });
  }
}
if(window.location.href.includes('?page=')){
window.location.replace(window.location.href.split('?')[0]);
}
pagination_click_fun();
function pagination_items_get_fun(loadMoreBtn){
  fetch(loadMoreBtn)
  .then(response => {
  return response.text();
  })
  .then(response => {
    
    const parser = new DOMParser();
    const html = parser.parseFromString(response, "text/html");
    let proGrid = document.querySelector("[data-product-main-wrapper]");
    if(proGrid){
      // replace product grid HTML
      proGrid.innerHTML = document.querySelector("[data-product-main-wrapper]").innerHTML + html.querySelector("[data-product-main-wrapper]").innerHTML;
      // replace pagination HTML
      window.history.replaceState({}, null, loadMoreBtn); // added curent pagination link
      let pagination = document.querySelector("[data-pagination-link]");
      let newPagination = html.querySelector("[data-pagination-link]");
      if(pagination && newPagination){
        pagination.innerHTML = newPagination.innerHTML;
        pagination_click_fun(); // reinit click event
      }
      get_cusrom_bundle_product();
      // let custom_bundal = document.querySelector("[data-custom-bundal-main-wapper]") || null;
      // if(custom_bundal){
      //   get_cusrom_bundle_product();
      // }     
    }
  });
}


function pagination_items_get_fun_collection(loadMoreBtn){
  fetch(loadMoreBtn)
  .then(response => {
  return response.text();
  })
  .then(response => {
     const parser = new DOMParser();
      const html = parser.parseFromString(response, "text/html");
        let new_custom_bundal = html.querySelector("[data-custom-bundal-main-wapper]");
        let custom_bundal = document.querySelector("[data-custom-bundal-main-wapper]") || null;
        if(custom_bundal && new_custom_bundal){
          custom_bundal.innerHTML = new_custom_bundal.innerHTML;
            const plus_input_quantity = document.querySelectorAll(".karton-coll-input-qty[name='quantity']");
            if(plus_input_quantity){
              plus_input_quantity.forEach((b ,index) => {
                 b.value = 0;
              });
            }
             const plus_buttpn = document.querySelectorAll("[data-product-main-wrapper] .karton-coll-input[name='plus']");
            if(plus_buttpn){
              plus_buttpn.forEach((b ,index) => {
                  var previousValue_check = b.closest('quantity-input').querySelector('input');
                  var total_pro_add = parseInt(previousValue_check.getAttribute('data-stap'));
                  var uncheck_number = parseInt(previousValue_check.max);
                    if(total_pro_add <= uncheck_number){
                        b.classList.remove('disabled');
                        document.getElementById('data-add-bundle-button').removeAttribute("disabled");
                    }else{
                        b.classList.add('disabled');
                        document.getElementById('data-add-bundle-button').setAttribute("disabled","true");
                    }
              });
            add_bundle_product();
            }
        }
    });
}

// faq tabs toggal start

      function togal_tabs (item) {
        item.addEventListener("click", () => {
           toggal_all_tabs(item.getAttribute('data-faq_content'));
        });        
      }
        function toggal_all_tabs(tabs_data){
                let tabs_button = document.querySelectorAll("[data-faq_content]");
                            tabs_button.forEach(b => {
                              if(b.getAttribute('data-faq_content') == tabs_data){
                                if(b.classList.contains('is_open')){
                                   b.classList.remove("is_open");    
                                  }else{
                                   b.classList.add("is_open");
                                  }
                              }else{
                                 b.classList.remove("is_open");
                              }
                              });
                           
              }
function faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
      tabs_title.forEach(togal_tabs);
}
      faq_taggol();


// faq tabs toggal end


// faq tabs toggal content start
      function tab_mai_mappert(item) {
        item.addEventListener("click", () => {
           toggal_all_tabs_content(item.getAttribute('data-hendles'));
        });        
      }
        function toggal_all_tabs_content(tabs_data){
                let tabs_content_toggel = document.querySelectorAll("[data-hendles]");
                            tabs_content_toggel.forEach(b => {
                              if(b.getAttribute('data-hendles') == tabs_data){
                                   b.classList.add("active");
                                  document.querySelector(b.getAttribute('data-hendles')).style.display = 'block';
                              }else{
                                 b.classList.remove("active");
                                 document.querySelector(b.getAttribute('data-hendles')).style.display = 'none';
                              }
                              });
                           
              }
      let tabs_content  = document.querySelectorAll("[data-hendles]");
      tabs_content.forEach(tab_mai_mappert);
// faq tabs toggal content end


     // Add this code make menu appears image hover
      function bindMouseOverToMegaMenu_images (item) {
        item.addEventListener("mouseover", () => {
           image_hide(item.getAttribute('data-image-name'));
          let image = document.querySelector(".header__inline-menu").querySelector("img.col_image")
          item.addEventListener("mouseleave", () => {
            image_hide();
          });
        });
      }
        function image_hide(imag){
             let images_val = document.querySelector(".header__inline-menu").querySelectorAll("img.col_image");
              images_val.forEach(b => {
              if(b.alt == imag){
                b.classList.remove("hidden");
              }else{
                b.classList.add("hidden");
              }
                });
          }
    let main_images = document.querySelector(".header__inline-menu");
    if(main_images){
      let images = main_images.querySelectorAll("[data-image-name]");
      images.forEach(bindMouseOverToMegaMenu_images);
    }



// recantely product script
    window.theme = window.theme || {};
theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};


theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');
    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
    }


window.localStorage.removeItem('bundleproducts');
theme.customBundle = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};

theme.customBundle.localStorage = window.localStorage.getItem('bundleproducts');
    if (theme.customBundle.localStorage) {
      theme.customBundle.recent = JSON.parse(theme.customBundle.localStorage);
    }

theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = window.cartStrings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();

theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering
  
      if (typeof callback === 'function') {
        callback();
      }
    },
  
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };

theme.buildProductGridItem = function(items, gridWidth, rowOf, imageSizes,enable_quick_add) {
    var output = '';
  
    items.forEach(product => {
      var image = theme.buildProductImage(product, imageSizes);
  
        let priceMarkup = `<div class="grid-product__price">${theme.Currency.formatMoney(product.price_min, theme.moneyFormat)}</div>`;
      let vendorMarkup = `<div class="grid-product__vendor">${product.vendor}</div>`;
     let quick_add_code = '';
      if (enable_quick_add) quick_add_code = `<product-form data-section-id="{{ section.id }}"><form method="post" action="/cart/add" id="quick-add-${product.id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id"><input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id"><button id="quick-add-${product.id}-submit" type="submit"name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" aria-labelledby="quick-add-${product.id}-submit title-${product.id}"aria-live="polite" data-sold-out-message="true" <span>ADD TO CART</span><div class="loading__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></button></form></product-form>`;
      var markup = `
        <div class="${gridWidth}">
          <div class="grid-product__content">
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${image}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${product.title}</div>
                ${priceMarkup}
                ${vendorMarkup}
                ${quick_add_code}
              </div>
            </a>
          </div>
        </div>
      `;
  
      output += markup;
    });

    return output;
  };

theme.buildProductGridItem_bundle = function(items, imageSizes) {
    var output = '';
    var bundle_v_id ;
    items.forEach(product => {
      var image = theme.buildProductImage(product, imageSizes);
      // if(!product.variants[0].available){
      //   product.variants.forEach(vari => {
      //     if(vari.available){
      //       bundle_v_id = vari.id;
      //       return;
      //     }
      //   });
      // }else{
      //   bundle_v_id = product.variants[0].id
      // }

          // console.log(product.selected_var);
          bundle_v_id = product.selected_var.id;
       // bundle_v_id = product.variants[0].id
          let priceMarkup = `<price>${theme.Currency.formatMoney(product.selected_var.price, theme.moneyFormat)}</price>`;
       // let priceMarkup = `<price>${theme.Currency.formatMoney(product.price_min, theme.moneyFormat)}</price>`;
      var markup = `
        <div class="added_product">
          <div class="added_item">
            <a href="${product.url}" class="grid-product__link">
              <div class="product-image">
                ${image}
              </div>
               <div class="product_details">
                <span>${product.title}</span>
                ${priceMarkup}
              </div>
            </a>
          </div>
          <div class="custom_quantity_selector">
            <quantity-input class="quantity" data-url="${product.handle}">
              <button class="quantity__button no-js-hidden" name="minus" type="button">
                <span class="visually-hidden">-</span>
              </button>
              <input
                class="quantity__input"
                type="number"
                name="quantity"
                value="${product.qty_value}"
                min="0"
                max="${product.max}"
                data-custom-check
                data-bundles-added-products
                data-vid=${bundle_v_id}
                data-price="${product.price_min}"
                data-max-qty="12"
                data-seling-plan-one-mo="${product.one_month}"
                data-seling-plan-two-mo="${product.two_month}"
                data-seling-plan-three-mo="${product.three_month}"
                data-stap-bundle="${product.qty_step}"
              />
              <button class="quantity__button no-js-hidden karton-coll-input-list" name="plus" type="button">
                <span class="visually-hidden">+</span>
              </button>
            </quantity-input>
          </div>         
        </div>
      `;
  
      output += markup;
    });

    return output;
  }


 theme.buildProductImage = function(product, imageSizes) {
    var size = 'natural';
    var output = '';
  
    if (size === 'natural') {
      const template = document.getElementById("naturalImageMarkup");
      const clonedMarkup = template.content.cloneNode(true);
      const imageEl = clonedMarkup.querySelector('img');
      const imageWrapperEl = clonedMarkup.querySelector('.image-wrap');
  
      imageWrapperEl.style.paddingBottom = `${product.image_aspect_ratio}%`;
  
      addImageProperties(imageEl, imageSizes);
  
      const imageDiv = document.createElement('div');
      imageDiv.appendChild(clonedMarkup);
  
      output = imageDiv.innerHTML;
(function() {
})();    } else {
      const template = document.getElementById("fixedRatioImageMarkup");
      const clonedMarkup = template.content.cloneNode(true);
      const imageEl = clonedMarkup.querySelector('img');
      const imageWrapperEl = clonedMarkup.querySelector('.grid__image-ratio');
  
      imageWrapperEl.classList.add(`grid__image-ratio--${size}`);
  
      if (!theme.settings.productImageCover) {
        imageEl.classList.add('grid__image-contain');
      }
  
      addImageProperties(imageEl, imageSizes);
  
      const imageDiv = document.createElement('div');
      imageDiv.appendChild(clonedMarkup);
  
      output = imageDiv.innerHTML;
    }
  
    function addImageProperties(imageEl, imageSizes) {
      imageEl.src = product.image_responsive_url;
      imageEl.srcset = product.image_responsive_urls.toString();
      imageEl.alt = product.title;
      imageEl.sizes = imageSizes;
    }
  
    return output;
  }



//end 


document.querySelectorAll(".item").forEach(element => {
  if(element.classList.contains("active")) {
    element.classList.remove("active")
  }
  element.addEventListener("click", function(e) {
    
    if(document.querySelector(".item.active")) {
      document.querySelector(".item.active").classList.remove("active")
    }
    if(element.classList.contains("active")) {
      element.classList.remove("active")
    } else {
      element.classList.add("active")
    }

  })
});


// custom bundal code start 

function get_cusrom_bundle_product() { 
  // console.log("vktest");
  const this_obj = document.querySelector("[data-bundle-products-list]") || null;
  if(this_obj){
  const subTotalprice = document.querySelector("[data-bundal-total]");
   const images_size = this_obj.getAttribute('data-image-sizes');
   var bundle_subtotal = 0;
  var promises = [];
        Object.keys(theme.customBundle.recent).forEach(function(handle) {
            if (handle !== 'undefined') {
                promises.push(getProductInfo(handle));
            }
        });
        Promise.all(promises).then(function(result) {
            setupOutput(result);
            // this.captureProductDetails(result);
        }.bind(this));
        
        function getProductInfo(handle) {
            return new Promise(function(resolve, reject) {
                if (theme.customBundle.productInfo.hasOwnProperty(handle)) {
                    resolve(theme.customBundle.productInfo[handle]);
                } else {
                    fetch('/products/' + handle + '.js').then(function(response) {
                        return response.text();
                    }).then(function(product) {
                        resolve(product);
                    });
                }
            });
        }
        
        function setupOutput(products) {
            var allProducts = [];
            var data = {};
            var limit = 12;
            var i = 0;
            var one_month = 0;
            var two_month = 0;
            var three_month = 0;
            var four_month = 0;
            var selected_var = null
            Object.keys(products).forEach(function(key) {
                if (!products[key]) {
                    return;
                }
                var product = JSON.parse(products[key]);

              //select product variant 

                 product.variants.forEach(vari => {
                    if(vari.title.includes('Mixkarton') || vari.title.includes('mixkarton')){
                      selected_var = vari
                    }
                  });     
               console.log(product.variants);
              if(!selected_var) return;
                // Ignore current product
                // Ignore undefined key

                // if(typeof parseInt(theme.customBundle.recent[product.handle].one_month) == 'number');

             
               if(typeof parseInt(theme.customBundle.recent[product.handle].one_month) == 'number') one_month =  one_month + (parseInt(theme.customBundle.recent[product.handle].one_month) * theme.customBundle.recent[product.handle].qty_value );
               if(typeof parseInt(theme.customBundle.recent[product.handle].two_month) == 'number')  two_month = two_month + (parseInt(theme.customBundle.recent[product.handle].two_month) * theme.customBundle.recent[product.handle].qty_value );
               if(typeof parseInt(theme.customBundle.recent[product.handle].therr_month) == 'number')  three_month = three_month + (parseInt(theme.customBundle.recent[product.handle].therr_month) * theme.customBundle.recent[product.handle].qty_value );
              if(typeof parseInt(theme.customBundle.recent[product.handle].four_month) == 'number')  four_month = four_month + (parseInt(theme.customBundle.recent[product.handle].four_month) * theme.customBundle.recent[product.handle].qty_value );
               // const product_price =  product.price_min * theme.customBundle.recent[product.handle].qty_value;
               const product_price =  selected_var.price * theme.customBundle.recent[product.handle].qty_value;
               bundle_subtotal = bundle_subtotal + product_price;
              const cheang_val =  document.querySelector('[data-product-main-wrapper]').querySelector(`[data-url="${product.handle}"]`);
                if(cheang_val){
                  cheang_val.querySelector('input').value = theme.customBundle.recent[product.handle].qty_value;
                }
              // console.log(product.handle);
              // console.log(theme.customBundle.recent[product.handle].qty_step);
                if (typeof product.handle == 'undefined') {
                    return;
                }
                i++;
                // New or formatted properties
                const widths = [180, 360, 540, 720, 900];
                product.qty_value = theme.customBundle.recent[product.handle].qty_value;
                product.qty_step = theme.customBundle.recent[product.handle].qty_step || 1;
                product.max = theme.customBundle.recent[product.handle].qty_max;
                product.one_month = theme.customBundle.recent[product.handle].one_month;
                product.two_month = theme.customBundle.recent[product.handle].two_month;
                product.three_month = theme.customBundle.recent[product.handle].therr_month;
                product.four_month = theme.customBundle.recent[product.handle].four_month;
                product.selected_var = selected_var;
                product.image_responsive_url = buildImagePath(product.featured_image),
                product.image_responsive_urls = buildImagePath(product.featured_image, widths);
                // Unit pricing checks first variant
                var firstVariant = product.variants[0];
                if (firstVariant && firstVariant.unit_price) {
                    var baseUnit = '';
                    if (firstVariant.unit_price_measurement) {
                        if (firstVariant.unit_price_measurement.reference_value != 1) {
                            baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
                        }
                        baseUnit += firstVariant.unit_price_measurement.reference_unit;
                    }
                    product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
                    if (baseUnit != '') {
                        product.unit_price += '/' + baseUnit;
                    }
                }
                allProducts.unshift(product);
            }.bind(this));
            if (allProducts.length === 0) {
                if (!this_obj.classList.contains('hidden'))this_obj.classList.add('hidden');
                // return;
            }else{
              if (this_obj.classList.contains('hidden'))this_obj.classList.remove('hidden');
            }
            var productMarkup = theme.buildProductGridItem_bundle(allProducts.slice(0, limit), images_size);
            this_obj.innerHTML = productMarkup;
            subTotalprice.innerHTML = theme.Currency.formatMoney(bundle_subtotal, theme.moneyFormat);
            subTotalprice.setAttribute("data-total-price",theme.Currency.formatMoney(bundle_subtotal, theme.moneyFormat));
          
console.log(one_month);
          const subcription_plan_selection =  document.querySelectorAll("[data-subscription-price]") || null;
          if(subcription_plan_selection.length > 0){
              subcription_plan_selection[0].innerHTML = theme.Currency.formatMoney(one_month, theme.moneyFormat);
              subcription_plan_selection[1].innerHTML = theme.Currency.formatMoney(two_month, theme.moneyFormat);
              subcription_plan_selection[2].innerHTML = theme.Currency.formatMoney(three_month, theme.moneyFormat);
             subcription_plan_selection[3].innerHTML = theme.Currency.formatMoney(four_month, theme.moneyFormat);
          }

          const subcription_plan_data =  document.querySelectorAll("[data-subscription-price]") || null;
           if(subcription_plan_data.length > 0){
              subcription_plan_data[0].setAttribute("data-total-price",theme.Currency.formatMoney(one_month, theme.moneyFormat));
              subcription_plan_data[1].setAttribute("data-total-price",theme.Currency.formatMoney(two_month, theme.moneyFormat));
              subcription_plan_data[2].setAttribute("data-total-price",theme.Currency.formatMoney(three_month, theme.moneyFormat));
             subcription_plan_data[3].setAttribute("data-total-price",theme.Currency.formatMoney(four_month, theme.moneyFormat));
           }

           const all_check_box = document.querySelectorAll("[name='bundle_product_input']");
           let len_checkval = parseInt( [].slice.call(all_check_box).filter(function(e) { return !e.checked; }).length);
           const plus_buttpn_minus = document.querySelectorAll(".karton-coll-input-list[name='plus']");
          console.log("testvk2",len_checkval);
            plus_buttpn_minus.forEach((b ,index) => {
              console.log("test1",len_checkval <= 0);
                if(len_checkval <= 0){
                    b.classList.add('disabled');
                    document.getElementById('data-add-bundle-button').removeAttribute("disabled");
                }else{
                   b.classList.remove('disabled');
                  document.getElementById('data-add-bundle-button').setAttribute("disabled","true");
                }
            });           
        }
        
        function buildImagePath(string, widths) {
            if (string == null) return [];
            if (widths) {
                const imageUrls = [];
                widths.forEach(width => {
                    let url = `${string}?width=${width}`;
                    if (width === widths[widths.length - 1]) {
                        url += ` ${width}w`
                    } else {
                        url += ` ${width}w,`
                    }
                    imageUrls.push(url);
                })
                return imageUrls;
            } else {
                return [string];
            }
        }
   }
}

// subcption checkbox check uncheck

// bundal add to cart js
function add_bundle_product(){

       const checkbox = document.getElementById('im-abo-kaufen') || null; 
       const subTotalprice = document.querySelector("[data-bundal-total]") || null;
          if(checkbox){
            checkbox.addEventListener('change', (event) => {
              if (event.currentTarget.checked) {
                document.querySelector("[data-custom-subscription-block]").classList.remove("hidden");
                document.getElementById('custom_selling_plan').value = document.querySelector('input[name="selling_plan"]:checked').value;
                if(subTotalprice){
                   subTotalprice.innerHTML = document.querySelector('input[name="selling_plan"]:checked').getAttribute('data-total-price');
                 }
              } else {
                document.querySelector("[data-custom-subscription-block]").classList.add("hidden");
                document.getElementById('custom_selling_plan').value = '';
                if(subTotalprice){
                   subTotalprice.innerHTML = subTotalprice.getAttribute('data-total-price');
                 }
              }
            })
        }
      document.querySelectorAll("input[name='selling_plan']").forEach((input) => {
              input.addEventListener('change', (event) => {
               document.getElementById('custom_selling_plan').value = event.target.value;
              });
          });

  
 let bundalsubmit = document.getElementById("data-add-bundle-button") || null;
  if(bundalsubmit){
    bundalsubmit.addEventListener("click",function(e) {
      e.preventDefault();
    let products = [];
      const properties = {};
          const product_list = document.querySelectorAll("[data-bundles-added-products]");


                        const gift_wipper_checkbox_card = document.getElementById('addgiftwapper') || null; 
                        if(gift_wipper_checkbox_card && gift_wipper_checkbox_card.checked){
                          const gift_wipper_checkbox_card_massage = document.getElementById('gift-message') || null;
                          const gift_wipper_error = document.getElementById('data-gift-massage-error') || null;
                            if(gift_wipper_checkbox_card_massage.value.length <= 0) {
                              if(gift_wipper_error) gift_wipper_error.classList.remove('hidden');
                              return;
                            }else{
                              if(gift_wipper_error) gift_wipper_error.classList.add('hidden');
                               properties['_Gift message'] = gift_wipper_checkbox_card_massage.value
                            }
                        }
    
                     properties['_Mix_Kiste'] = true;
            const selling_plan_val = document.getElementById('custom_selling_plan').value || null;
                product_list.forEach((b ,index) => {
                   let product = {};
                        product.id = b.getAttribute('data-vid');
                        product.quantity = b.value;
                         if(selling_plan_val){
                           product.selling_plan = selling_plan_val; 
                         }
                       product.properties = properties;
                      products.push(product);
                }); 
                const ADDTOCART_OBJECT = { items: products };
          custom_addtocart_fun(ADDTOCART_OBJECT,true,true);
        });
  }


      const selling_plan =  document.querySelectorAll('input[name="selling_plan"]') || null; 
          if(selling_plan){
                selling_plan.forEach((b) => {
                   b.addEventListener('change', (event) => {
                      console.log(subTotalprice);
                      if(subTotalprice){
                           subTotalprice.innerHTML = document.querySelector('input[name="selling_plan"]:checked').getAttribute('data-total-price');
                         }
                    });
                   });
        }

  
}
add_bundle_product();
//  custom bundal code end
function custom_addtocart_fun(product,open_drawer,is_collections){
      fetch(`${routes.cart_add_url}`,{ 
              method: 'POST',
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: JSON.stringify(product)
        })
        .then(response => response.json()).then(response => {     
          // console.log(response);   
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally((e) => {
          // console.log("finally");
          if(is_collections){
                 window.localStorage.removeItem('bundleproducts');
                theme.customBundle.recent = {};
                pagination_items_get_fun_collection(window.location.href, true);
                karton_gift_added();
          }
          if(open_drawer){
            const this_cartDrawer = document.querySelector('cart-drawer');
            this_cartDrawer.refresh(true);
          }
        });
}
function custom_cheangcart_fun(product,open_drawer,removegift,addtocart){
      fetch(`${routes.cart_change_url}`,{ 
              method: 'POST',
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: product
        })
        .then(response => response.json()).then(response => { 
          // console.log(response);        
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally((e) => {
          // console.log("finally");
          if(removegift){
             removegift.querySelector('cart-remove-button').querySelector('button').click();
          }
          if(addtocart){
            custom_addtocart_fun(addtocart,true);
          }
          if(open_drawer){
            const this_cartDrawer = document.querySelector('cart-drawer');
            this_cartDrawer.refresh(true);
          }
        });
}
function custom_updatecart_fun(updates,open_drawer){
  var count_data = 0;
     fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              body: updates
        })
        .then(response => response.json())
        .then(data => count_data = data)
        .finally((e) => {
          if(open_drawer){
            const this_cartDrawer = document.querySelector('cart-drawer');
            this_cartDrawer.refresh(true,count_data.item_count);
          }
        });
}

function karton_gift_added(){

       const gift_wipper_checkbox_card = document.getElementById('addgiftwapperproduct') || null; 
           const this_checkgift = document.querySelector('input[name="properties[_gift card]"]:checked');
           // const this_checkgift = document.getElementById('gift-card');
            if(gift_wipper_checkbox_card && this_checkgift){
                    if(gift_wipper_checkbox_card.checked && !this_checkgift.value == ''){
                            let products = [];
                            let product = {};
                            product.id = this_checkgift.value;
                            product.quantity = 1;
                            product.properties = {
                                '_Mix_Kiste_gift':true
                              }
                          products.push(product);
                    const ADDTOCART_OBJECT_GIFT = { items: products };
                     custom_addtocart_fun(ADDTOCART_OBJECT_GIFT,true);
                }
            }

  
  
}
// pdp gift wapper code start




// document.addEventListener("DOMContentLoaded", function () {
//   gift__checkbox();
// });

function gift__checkbox(gift_wipper_checkbox) {  
  if(gift_wipper_checkbox){
    console.log("test",gift_wipper_checkbox);
    gift_wipper_checkbox.addEventListener('change', (event) => {
      console.log("event.currentTarget.checked",event.currentTarget.checked)
      if (event.currentTarget.checked) {
        console.log("Hii checked show");
        document.querySelector("[data-main-gift-wapper]").classList.remove("hidden");
        document.getElementById('gift-message').disabled=false;
      } else {
        document.querySelector("[data-main-gift-wapper]").classList.add("hidden");
        console.log("Hii checked hide");
        document.getElementById('gift-message').disabled=true;
      }
    })
  };
  
  const gift_wipper_checkbox_card = document.getElementById('addgiftwapperproduct') || null; 
  if(gift_wipper_checkbox_card){
    const is_time_pro =  document.getElementById('gift-time') || null;
    gift_wipper_checkbox_card.addEventListener('change', (event) => {
      if (event.currentTarget.checked) {
        document.querySelector("[data-gift-card]").classList.remove("hidden");
        // document.getElementById('gift-card').disabled=false;
        if(is_time_pro) is_time_pro.disabled=false;
      } else {
        document.querySelector("[data-gift-card]").classList.add("hidden");
        // document.getElementById('gift-card').disabled=true;
        if(is_time_pro) is_time_pro.disabled=true;
      }
    })
  }

      
// const gift_change = document.getElementById('gift-card') || null; 
// if(gift_change){
//   gift_change.addEventListener('change', (event) => {
//   document.querySelector("[data-gift-content]").querySelector("gift-price").innerHTML =  event.target.querySelector('option[value="'+event.currentTarget.value+'"]').getAttribute('data-gift-price');
//   })
// }

  const gift_change = document.querySelectorAll("input[name='properties[_gift card]']");
  if (gift_change){
  gift_change.forEach((input) => {
       input.addEventListener('change', (event) => {
               document.querySelector("[data-gift-content]").querySelector("gift-price").innerHTML = event.target.getAttribute('data-gift-price');
        });
    });
  }
}


  function check_gift_product(is_open){
    const gift_popup = document.querySelector ('[data-gift-alear-main-wapper]') || null;
      if(document.querySelector('body').classList.contains('gift_is_added')){
         document.querySelector('body').classList.remove('gift_is_added');
      }
      if(document.querySelectorAll('[data-gift-items-is-added-on-cart]').length > 0){
         document.querySelector('body').classList.add('gift_is_added');
        if(gift_popup && is_open){
            setTimeout(() => {
              document.querySelector('cart-drawer').close();
              gift_popup.classList.remove('div-hide');
          }, "1000");
        }
      } 
  }

// pdp gift wapper code end



// PDP unavalable varient start 

(function() {

setTimeout(() => {
 const gift_wipper_checkbox = document.querySelector('#addgiftwapper') || null;
 if(gift_wipper_checkbox) gift__checkbox(gift_wipper_checkbox);

  const gift_wipper_checkbox_card_massage = document.getElementById('gift-message') || null;
  const gift_wipper_error = document.getElementById('data-gift-massage-error') || null;
    if(gift_wipper_checkbox_card_massage){
      gift_wipper_checkbox_card_massage.addEventListener('input', (event) => {
               if(gift_wipper_checkbox_card_massage.value.length <= 0) {
                    if(gift_wipper_error) gift_wipper_error.classList.remove('hidden');
                    return;
                  }else{
                    if(gift_wipper_error) gift_wipper_error.classList.add('hidden');
                  }
        });
    }
  
}, "1000");


  
 
  
  check_gift_product();


  const gift_popup = document.querySelector('[data-gift-alear-main-wapper]') || null;
  const gift_popup_close = document.querySelectorAll('[gift_popup_close]') || null;
  if(gift_popup && gift_popup_close){
      gift_popup_close.forEach(close_selector => {
          close_selector.addEventListener("click",function(e) {
             e.preventDefault();
             gift_popup.classList.add('div-hide');
          });
      });
  }

  
  if(document.querySelector('body').classList.contains('template-product')){

        const variantSelects = (document.querySelector('variant-selects')) ? document.querySelector('variant-selects') : document.querySelector('variant-radios');
        const pickerType = (variantSelects.querySelectorAll('fieldset').length > 0) ? 'radios' : 'selects';
        const fieldsets = (pickerType == 'radios') ? Array.from(variantSelects.querySelectorAll('fieldset')) : Array.from(variantSelects.querySelectorAll('.product-form__input--dropdown'));
        const productJson = JSON.parse(variantSelects.querySelector('[type="application/json"]').textContent);
        let selectedOptions = [];
        variantSelects.addEventListener('change', rebuildOptions);
        // this.rebuildOptions();
        
        function validCombo(inputValue, optionLevel) {
          for(let i = 0; i < productJson.length; i++) {
            if(optionLevel == 1){
              if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == inputValue) {  return true; }
            } else {
              if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == selectedOptions[1] && productJson[i].option3 == inputValue) {  return true; }
            }
          }
        }
        
        function rebuildOptions() {
            selectedOptions = fieldsets.map((fieldset) => {
                return (pickerType == 'radios') ? Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value : Array.from(fieldset.querySelectorAll('select'), (select) => select.value);
            });
            for(let optionLevel = 1, n = fieldsets.length; optionLevel < n; optionLevel++) {
                const inputs = (pickerType == 'radios') ? fieldsets[optionLevel].querySelectorAll('input') : fieldsets[optionLevel].querySelectorAll('option');
        
                inputs.forEach(input => {
                input.disabled = (validCombo(input.value,optionLevel)) ? false : true;
                if(pickerType == 'radios'){
                    const label = fieldsets[optionLevel].querySelector(`label[for="${input.id}"]`);
        
                    label.style.display = (input.disabled) ? "none" : ""; //Hide the option, or comment this line out and use the following lines to style it..
                    //label.style.opacity = (input.disabled) ? 0.5 : 1;
                    //label.style.borderStyle = (input.disabled) ? "dashed" : "solid";
                    //label.style.textDecoration = (input.disabled) ? "none" : "";
                } else {
                    input.hidden = (validCombo(input.value,optionLevel)) ? false : true;
                }
                });
            }
            for (let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false; optionLevel < fieldsetsLength && !change; optionLevel++) {
                if(pickerType == 'radios'){
                if(fieldsets[optionLevel].querySelector('input:checked').disabled === true) {
                    change = (fieldsets[optionLevel].querySelector('input:not(:disabled)').checked = true);
                }
                } else {
                if(fieldsets[optionLevel].querySelector('option:checked').disabled === true) {
                    change = (fieldsets[optionLevel].querySelector('option:not(:disabled)').selected = "selected");
                }
                }
                if(change) variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }

  }
})();


// PDP unavalable varient end 





$(document).on("click",".box-result-bar .box-result-header",function(){
  if ($(window).width() < 990) {
  $(".box-result-bar .yourBox_sidebar .sidebar_header").slideToggle();
  $(this).toggleClass("active");
  }
});
$(document).on("click",".custom_quantity_selector .quantity__button",function(){
  if ($(window).width() < 990) {
  $(".box-result-bar .yourBox_sidebar .sidebar_header").slideDown();
  $(".box-result-bar .box-result-header").removeClass("active");
  $(".box-result-bar .box-result-header").addClass("active");
}
});


(function() { 
const popup_open = document.querySelectorAll('[data-popup-open]') || null;
  if(popup_open){
      popup_open.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
           const main_popup = document.querySelector(event.target.hash) || null;
        console.log(main_popup);
          if(!main_popup) return;
                 main_popup.classList.add("open"); 
                 document.body.classList.add("popup_open");
        });
     });
  }  

  const popup_close = document.querySelectorAll('[data-popup-close]') || null;
  if(popup_close){
      popup_close.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
           const main_popup = event.target.closest('[data-poup]') || null;
          if(!main_popup) return;
                 main_popup.classList.remove("open"); 
                 document.body.classList.remove("popup_open");
        });
     });
  } 
  });